export default {
  productFilterNone: { id: 'product_filter_none', defaultMessage: 'All' },
  productFilterSearch: {
    id: 'product_filter_search',
    defaultMessage: 'Search for {facet}',
  },
  clear: {
    id: 'searchbar_clear',
    defaultMessage: 'clear',
  },
  foundFilterOptions: {
    id: 'found_filter_options',
    defaultMessage: `{count, plural,
      =0 {No filter options found.}
      one {# filter option found.}
      other {# filter options found.}
    }`,
  },
}
